import React from 'react';
import { Image } from '@chakra-ui/react';
import siesa1 from '../../img/siesa1-480.webp';
import logo2 from '../../img/logo2.png';
import logoSimple from '../../img/logoSimple.png';

const LOGO_SOURCES = {
  navbar: siesa1,
  footer: logo2,
  default: logoSimple,
};

const INTRINSIC_SIZE_BY_SRC = {
  [siesa1]: { width: 480, height: 320 },
  [logo2]: { width: 584, height: 623 },
  [logoSimple]: { width: 250, height: 61 },
};

/**
 * Componente centralizado para la identidad de marca de SIESA.
 * - variant="navbar": Usa siesa1.png (logo principal destacado para el header)
 * - variant="footer": Usa logo2.png (para el pie de página)
 * - Por defecto: Usa logoSimple.png
 */
export default function SiesaLogo({
  variant = 'darkOnLight',
  src,
  alt = 'SIESA',
  w,
  h,
  maxH,
  htmlWidth,
  htmlHeight,
  loading,
  fetchPriority,
  ...props
}) {
  const logoSrc = src || LOGO_SOURCES[variant] || LOGO_SOURCES.default;
  const intrinsicSize = INTRINSIC_SIZE_BY_SRC[logoSrc];
  const effectiveLoading =
    loading || (variant === 'footer' ? 'lazy' : undefined);
  const effectiveFetchPriority =
    fetchPriority || (variant === 'navbar' ? 'high' : undefined);

  return (
    <Image
      src={logoSrc}
      alt={alt}
      htmlWidth={htmlWidth || intrinsicSize?.width}
      htmlHeight={htmlHeight || intrinsicSize?.height}
      w={w || 'auto'}
      h={h || 'auto'}
      maxH={maxH}
      loading={effectiveLoading}
      fetchPriority={effectiveFetchPriority}
      objectFit="contain"
      {...props}
    />
  );
}
